import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "1em",
	viewBox: "-4 -4 32 32",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.8,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m10 14 4-4" }),
			/* @__PURE__ */ _jsx("path", { d: "m8.5 16.5-1.5 1.5a3 3 0 0 1 -4.25-4.25l3-3a3 3 0 0 1 4.25 0" }),
			/* @__PURE__ */ _jsx("path", { d: "m15.5 7.5 1.5-1.5a3 3 0 1 1 4.25 4.25l-3 3a3 3 0 0 1 -4.25 0" })
		]
	})
});
export default SvgLink;
